var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonFormIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10H6M8.5 14H6M16 6H6M21 5.8V16.2C21 17.8802 21 18.7202 20.5913 19.362C20.2317 19.9265 19.6581 20.3854 18.9525 20.673C18.1503 21 17.1002 21 15 21H7C4.8998 21 3.8497 21 3.04754 20.673C2.34193 20.3854 1.76825 19.9265 1.40873 19.362C1 18.7202 1 17.8802 1 16.2V5.8C1 4.11984 1 3.27976 1.40873 2.63803C1.76825 2.07354 2.34193 1.6146 3.04754 1.32698C3.8497 1 4.8998 1 7 1H15C17.1002 1 18.1503 1 18.9525 1.32698C19.6581 1.6146 20.2317 2.07354 20.5913 2.63803C21 3.27976 21 4.11984 21 5.8Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonFormIcon);
export default __webpack_public_path__ + "static/media/CommonFormIcon.2e14480548798fb47bcd61fcdc89ddd8.svg";
export { ForwardRef as ReactComponent };